import React, { useEffect, useRef } from "react";
import "./about.scss";
import img1 from "../../assets/about/img1.webp";
import img2 from "../../assets/about/img2.webp";
import img3 from "../../assets/about/img3.webp";
import SectionHeader from "../section_header/SectionHeader";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import CountUp from "react-countup";
gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const headingRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      headingRef.current,
      { color: "lightgray", fontWeight: "bold" }, // initial
      {
        color: "#cf3934", // final
        fontWeight: "bold",
        scrollTrigger: {
          trigger: headingRef.current,
          start: "top 80%",
          end: "top 40%",
          scrub: true,
        },
      }
    );
  }, []);
  return (
    <div className="about_main">
      <div className="about_header">
        <SectionHeader name={"ABOUT"} />
      </div>
      <div className="about_container">
        <div className="about_words">
          <div className="about_words_section1">
            <h3 ref={headingRef}>Designing Tomorrow’s Spaces Today</h3>
          </div>
          <p>
            Experience innovative architecture that transforms your ideas into
            reality. We craft functional, aesthetic, and timeless environments
            through thoughtful design, meticulous detailing, and a deep
            understanding of how people live and interact.
          </p>
        </div>
        <div className="about_cards">
          <div
            className="about_card"
            style={{ backgroundImage: `url(${img1})` }}
          >
            <h3>
              {" "}
              <CountUp
                start={5000}
                end={90000}
                duration={3}
                enableScrollSpy={true}
                scrollSpyOnce={true}
              />
              + SQFT DESIGNED
            </h3>
          </div>
          <div
            className="about_card"
            style={{ backgroundImage: `url(${img2})` }}
          >
            <h3>
              <CountUp
                scrollSpyOnce={true}
                duration={4}
                enableScrollSpy={true}
                end={100}
              />
              + PROJECTS
            </h3>
          </div>
          <div
            className="about_card"
            style={{ backgroundImage: `url(${img3})` }}
          >
            <h3>
              <CountUp
                scrollSpyOnce={true}
                duration={5}
                enableScrollSpy={true}
                end={5}
              />
              + YEARS OF EXPERIENCE
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
